import { useContext } from 'react';

import { RouteContext } from 'src/context';
import {
  isOnboardingStep,
  OnboardingQueryParams,
} from 'src/routes/onboarding/setup/types';

export const useOnboardingQueryParams = () => {
  const { query } = useContext(RouteContext);
  const { prefill_email, template_id, template_name, step, ...queryParams } =
    query as OnboardingQueryParams;

  return {
    prefillEmail:
      prefill_email !== undefined
        ? decodeURIComponent(prefill_email)
        : undefined,
    workspaceTemplateId: template_id,
    workspaceTemplateName: template_name,
    step: isOnboardingStep(step) ? step : undefined,
    ...queryParams,
  } as const;
};
